import {Injectable} from '@angular/core';
import {TrackingUpdateEventArgument} from '../model/tracking-update-event-argument';
import {ContextType, PriceBoxCommunicationService} from './price-box-communication.service';
import {TariffOptionConfiguration} from '../model/tariff-option-configuration';


interface IDataLayer {
  push(o: any);
}

class DataLayerComp implements IDataLayer {
  public push(o: any) {}
}

interface IWindow {
  dataLayer: IDataLayer;
}

declare var window: IWindow;

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  private isActive = true;
  private dataLayer: IDataLayer;
  private priceBoxComSvc: PriceBoxCommunicationService;

  constructor(priceBoxComSvc: PriceBoxCommunicationService) {

    this.priceBoxComSvc = priceBoxComSvc;

    if (window.dataLayer) {
      this.dataLayer = window.dataLayer;
    } else {
      this.dataLayer = new DataLayerComp();
    }
  }

  public track(dataEventAction: string, dataEventLabel: string): void {
    if (!this.isActive) {
      return;
    }

    this.dataLayer.push({
      event: 'appEvent',
      'data-event-category': 'tarifbox',
      'data-event-action': dataEventAction,
      'data-event-label': dataEventLabel
    });
  }

  public trackHelpClick(dataEventLabel: string) {
    this.track('hilfetext', dataEventLabel);
  }

  public trackShowMorelick(dataEventLabel: string) {
    this.track('mehr anzeigen', dataEventLabel);
  }

  public updatePriceBoxTrackingData(contextType: ContextType, tariffOptions: Map<string, TariffOptionConfiguration>) {
    const arg: TrackingUpdateEventArgument = new TrackingUpdateEventArgument(contextType.toString());
    let trackingAttributesString = contextType.toString();

    tariffOptions.forEach((value: TariffOptionConfiguration, key: string) => {
      if (value.active) {
        arg.addCalculationId(key);
        trackingAttributesString += ' ' + key;
      }
    });

    this.priceBoxComSvc.triggerTrackingUpdate(arg, contextType, trackingAttributesString);
  }
}
